import { motion } from "framer-motion";
import { Link } from "react-router-dom"

const steps = [
    {
        title: "Consulta Virtual Gratis",
        desc: "Analizamos tu caso por WhatsApp o Zoom. Nos cuentas tu problema y revisamos la situación actual de tu predio.",
        icon: "💬"
    },
    {
        title: "Diagnóstico Técnico/Legal",
        desc: "Revisamos partidas registrales y documentos. Te decimos qué falta y cuál es el camino más rápido.",
        icon: "🔍"
    },
    {
        title: "Gestión y Elaboración",
        desc: "Si no tienes tiempo, nosotros armamos el expediente, dibujamos los planos y gestionamos el trámite por ti.",
        icon: "📂"
    },
    {
        title: "Resultado Garantizado",
        desc: "Recibes tu propiedad formalizada o tu plano visado sin salir de casa. ¡Trámite resuelto!",
        icon: "✅"
    }
];

const Process = () => {
    return (
        <section className="py-24 bg-[#1C1C1C] text-white overflow-hidden" id="tramites" >
            <div className="max-w-7xl mx-auto px-6">

                <div className="text-center mb-20">
                    <h2 className="text-4xl md:text-5xl font-black tracking-tighter">
                        Tu trámite en <span className="text-[#F26B1D]">buenas manos</span>
                    </h2>
                    <p className="mt-4 text-gray-400 text-lg max-w-2xl mx-auto">
                        Te orientamos virtualmente o gestionamos todo el proceso. Tú eliges cuánta ayuda necesitas.
                    </p>
                </div>

                <div className="grid md:grid-cols-4 gap-8 relative">
                    {/* Línea decorativa que une los pasos (Solo visible en desktop) */}
                    <div className="hidden md:block absolute top-12 left-0 w-full h-[2px] bg-gradient-to-r from-[#F26B1D]/0 via-[#F26B1D]/30 to-[#F26B1D]/0 z-0" />

                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2 }}
                            whileHover={{ y: -10 }}
                            className="relative z-10 flex flex-col items-center text-center group"
                        >
                            {/* Círculo con Número e Icono */}
                            <div className="w-20 h-20 rounded-2xl bg-[#252525] border border-gray-800 flex items-center justify-center mb-6 group-hover:border-[#F26B1D] transition-colors relative">
                                <span className="text-3xl">{step.icon}</span>
                                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-[#F26B1D] text-white text-xs font-bold flex items-center justify-center shadow-lg">
                                    0{index + 1}
                                </div>
                            </div>

                            <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#F26B1D] transition-colors">
                                {step.title}
                            </h3>

                            <p className="text-gray-400 text-sm leading-relaxed">
                                {step.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>

                {/* Botón de acción rápida debajo del proceso */}
                {/* Botón de acción rápida actualizado */}
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    className="mt-20 text-center flex justify-center"
                >
                    <div className="inline-flex flex-col md:flex-row items-center gap-6 p-6 md:px-10 rounded-3xl bg-[#252525] border border-gray-800 shadow-2xl">
                        <p className="text-gray-300 font-medium text-lg">
                            ¿Tienes un documento y no sabes por dónde empezar?
                        </p>

                        <Link
                            to="/contacto"
                            className="px-8 py-4 bg-[#F26B1D] text-white font-bold rounded-2xl shadow-lg shadow-[#F26B1D]/20 hover:scale-105 transition-all active:scale-95 text-center"
                        >
                            Consultar ahora
                        </Link>
                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default Process;